import { useSearchParams, Link } from "react-router-dom"
import { Card, CardContent } from "@/components/ui/card"

export default function LoginVerifyPage() {
  const [searchParams] = useSearchParams()
  const email = searchParams.get("email")

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <Card className="w-full max-w-md p-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-4">
            <svg
              className="h-6 w-6 text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Check your email
          </h1>

          <p className="text-gray-600 mb-6">
            {email ? (
              <>
                We've sent a sign-in link to <strong>{email}</strong>
              </>
            ) : (
              "We've sent you a sign-in link"
            )}
          </p>

          <CardContent className="bg-blue-50 border border-blue-200 rounded-md p-4 text-left">
            <p className="text-sm text-blue-900 mb-2">
              <strong>Next steps:</strong>
            </p>
            <ol className="text-sm text-blue-800 space-y-1 list-decimal list-inside">
              <li>Check your email inbox</li>
              <li>Click the "Sign In" button in the email</li>
              <li>You'll be automatically signed in</li>
            </ol>
          </CardContent>

          <div className="mt-6 text-sm text-gray-600">
            <p className="mb-2">
              <strong>Didn't receive the email?</strong>
            </p>
            <ul className="space-y-1 text-left">
              <li>• Check your spam or junk folder</li>
              <li>• Make sure you entered the correct email address</li>
              <li>• The link expires in 24 hours</li>
            </ul>
          </div>

          <div className="mt-8">
            <Link
              to="/login"
              className="text-sm text-blue-600 hover:text-blue-800 underline"
            >
              Back to sign in
            </Link>
          </div>
        </div>
      </Card>
    </div>
  )
}

